import React from 'react'
import PureSelect from '../pure-select.component'
import CreditCardFields from '../credit-card-fields/credit-card-fields.component'
import { connect } from 'react-redux'
import { Checkbox } from 'semantic-ui-react'
import { mapCardBrandToIcon } from '../../credit-cards/credit-cards-list.component'
import { CheckboxToggleInput } from './../../../components/form-components/inputs.component'
import { cardYearValidityOptions } from './credit-card-fields.component'
import { Creators as SiteCreators } from '../../../ducks/site/site'
import { Creators as CreditCardPurchaseCreators } from '../../../ducks/credit-card-purchase/credit-card-purchase'
import {
	CreditCardInput,
	SecurityCodeInput,
	TextInput
} from '../inputs.component'
import './style/save-credit-card-fields.style.css'
import { getCreditCardInstallmentOptions } from '../../../modules/private/client/ticket-sale/creditcard-installment-options'
import { mapApiInstallments } from '../../../helpers'

class SaveCreditCardFields extends React.PureComponent {
	constructor(props) {
		super(props)

		this.state = {
			cardOpen: {},
			otherCards: [],
			creditCards: [],
			setFieldCount: 0,
			showNewCard: false,
			safeBoxCreditCards: [],
			installmentOptions: []
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.values.selectsavecard && this.state.showNewCard) {
			document.getElementById('payment-new-card').click()
			this.setField(this.state.cardOpen)
		}
		if (nextProps.safeBoxCreditCards)
			if (nextProps.safeBoxCreditCards.cards)
				if (
					nextProps.safeBoxCreditCards.cards !==
					this.state.safeBoxCreditCards
				)
					this.setState({
						safeBoxCreditCards: nextProps.safeBoxCreditCards.cards
					})

		if (nextProps.creditCards)
			if (nextProps.creditCards !== this.state.creditCards)
				this.setState({
					creditCards: nextProps.creditCards
				})

		if (
			!nextProps.apiPaymentMethodsLoading &&
			(this.state.installmentOptions.length === 0 ||
				(nextProps.orderValue && nextProps.orderValue !== this.props.orderValue) ||
				nextProps.apiInstallments !== this.props.apiInstallments)
		) {
			if (nextProps.apiInstallments) {
				this.setState({
					installmentOptions: mapApiInstallments(
						nextProps.apiInstallments,
						nextProps.orderValue,
						{ showAVista: true }
					)
				})
			} else if (nextProps.disableLegacyInstallments) {
				// Checkout novo: payments/methods do carrinho e fonte unica - sem
				// fallback pro endpoint legado.
				this.setState({ installmentOptions: [] })
			} else {
				getCreditCardInstallmentOptions(nextProps.orderValue)
					.then(data => {
						this.setState({ installmentOptions: data })
					})
			}
		}
	}

	refreshProps = () => {
		const { safeBoxCreditCards, creditCards } = this.props

		if (safeBoxCreditCards)
			if (safeBoxCreditCards.cards)
				if (safeBoxCreditCards.cards !== this.state.safeBoxCreditCards)
					this.setState({
						safeBoxCreditCards: safeBoxCreditCards.cards
					})

		if (creditCards)
			if (creditCards !== this.state.creditCards)
				this.setState({
					creditCards: creditCards
				})
	}

	cleanFields = () => {
		this.props.setFieldValue('cardId', '')
		this.props.setFieldValue('cardNumber', '')
		this.props.setFieldValue('cardPrintedName', '')
		this.props.setFieldValue('cardNumberToken', '')
		this.props.setFieldValue('cardYearValidity', '')
		this.props.setFieldValue('cardMonthValidity', '')
	}

	setField = card => {
		this.props.setFieldValue('cardId', card.cardId)
		this.props.setFieldValue('cardNumber', card.cardNumber)
		this.props.setFieldValue('cardPrintedName', card.cardPrintedName)
		this.props.setFieldValue('cardNumberToken', card.cardNumberToken)
		this.props.setFieldValue('cardYearValidity', card.cardYearValidity)
		this.props.setFieldValue('cardMonthValidity', card.cardMonthValidity)
	}

	setSaveCards = () => {
		const { creditCards, setFieldCount, safeBoxCreditCards } = this.state

		let firstCard = creditCards.filter(card => card.main && card.active)
		if (firstCard.length === 0)
			firstCard = creditCards.filter(card => card.active)

		let otherCards = []
		if (creditCards.length > 1)
			otherCards = creditCards.filter(
				card => card.main !== true && card.active
			)

		const auxFirstCard = safeBoxCreditCards.filter(
			card => card.last_four_digits === firstCard[0].lastFourDigits
		)[0]
		const firstCardHolderName = auxFirstCard.cardholder_name
		const numberToken = auxFirstCard.number_token
		const cardId = auxFirstCard.card_id
		const cardExpirationYear = auxFirstCard.expiration_year
		const cardExpirationMonth = auxFirstCard.expiration_month
		const cardBrand = auxFirstCard.brand

		const firstCardFiltred = {
			cardId,
			cardNumberToken: numberToken,
			cardPrintedName: firstCardHolderName,
			cardYearValidity: firstCard[0].expirationYear || cardExpirationYear,
			cardMonthValidity: firstCard[0].expirationMonth || cardExpirationMonth,
			cardNumber: '000000000000' + firstCard[0].lastFourDigits,
			cardBrand
		}

		let otherCardsFiltred = []

		otherCards.map(card => {
			if (card.lastFourDigits !== firstCard[0].lastFourDigits) {
				const auxCard = safeBoxCreditCards.filter(
					safeCard => safeCard.last_four_digits === card.lastFourDigits
				)[0]
				const cardHolderName = auxCard.cardholder_name
				const numberToken = auxCard.number_token
				const cardId = auxCard.card_id
				const cardExpirationYear = auxCard.expiration_year
				const cardExpirationMonth = auxCard.expiration_month
				const cardBrand = auxCard.brand

				const newOtherCard = {
					cardId,
					cardNumberToken: numberToken,
					cardPrintedName: cardHolderName,
					cardYearValidity: card.expirationYear || cardExpirationYear,
					cardMonthValidity: card.expirationMonth || cardExpirationMonth,
					cardNumber: '000000000000' + card.lastFourDigits,
					cardBrand
				}

				otherCardsFiltred.push(newOtherCard)
			}
		})

		this.setField(firstCardFiltred)

		this.setState({
			cardOpen: firstCardFiltred,
			otherCards: otherCardsFiltred,
			setFieldCount: setFieldCount + 1
		})
	}

	setSaveCardFieldsToPurchase = card => {
		const { cardOpen, otherCards } = this.state
		const { showLoading, hideLoading, values } = this.props
		const toggleCardOpen = document.getElementById('selectsavecard')

		values.selectsavecard ? toggleCardOpen.click() : null

		showLoading()
		setTimeout(() => {
			const refreshOtherCards = otherCards.filter(
				otherCard => card.cardNumber !== otherCard.cardNumber
			)

			refreshOtherCards.push(cardOpen)
			const sortedRefreshedOtherCards = refreshOtherCards.sort(
				(cardA, cardB) => {
					if (cardA.order < cardB.Order) return -1
					if (cardB.order < cardA.Order) return 1
					return 0
				}
			)

			this.setField(card)
			this.setState({
				cardOpen: card,
				otherCards: sortedRefreshedOtherCards
			})

			toggleCardOpen.click()
			hideLoading()
		}, 2000)
	}

	renderWithOtherCard = () => {
		this.cleanFields()
		if (this.props.values.selectsavecard) {
			document.getElementById('selectsavecard').click()
		}
		this.setState({ showNewCard: !this.state.showNewCard })
	}

	render() {
		const { installmentOptions } = this.state
		const {
			cardOpen,
			otherCards,
			creditCards,
			setFieldCount,
			safeBoxCreditCards
		} = this.state

		if (
			creditCards.length > 0 &&
			safeBoxCreditCards.length > 0 &&
			setFieldCount === 0
		)
			this.setSaveCards()

		if (creditCards.length === 0) {
			this.refreshProps()
		}

		return (
			<React.Fragment>
				<div className="form-savecard">
					{otherCards.length > 0
						? otherCards.map((card, index) => (
							<div
								className={`other-save-card-container last-card-${otherCards.length - 1 === index ? 'true' : 'false'
									}`}>
								<Checkbox
									toggle
									id="checkbox-savecard"
									checked={false}
									onChange={(a, b) => {
										b.checked
											? this.setSaveCardFieldsToPurchase(card)
											: null
									}}
								/>
								<div
									className="card-number"
									onClick={() => {
										document
											.getElementById('checkbox-savecard')
											.click()
									}}>
									{mapCardBrandToIcon(card.cardBrand)}
									{card.cardNumber
										? `**** **** **** ${card.cardNumber.slice(
											12,
											16
										)}`
										: `**** **** **** !!!!`}
								</div>
							</div>
						))
						: null}

					<div className={`select-savecard select-savecard-${this.props.values.selectsavecard}`}>
						<CheckboxToggleInput id={`selectsavecard`} {...this.props} />
						<div
							onClick={() => {
								document.getElementById('selectsavecard').click()
							}}
							className="card-number">
							{cardOpen.cardBrand
								? mapCardBrandToIcon(cardOpen.cardBrand)
								: null}
							{cardOpen.cardNumber
								? `**** **** **** ${cardOpen.cardNumber.slice(12, 16)}`
								: `**** **** **** !!!!`}
						</div>
						<div className={`show-field-container`}>
							<CreditCardInput
								{...this.props}
								id={`${this.state.showNewCard ? 'hidden' : 'cardNumber'
									}`}
								className={`cardNumber field-show-${this.state.showNewCard}`}
								label="Número do cartão"
								onComplete={creditCardNumber =>
									this.props.setCreditCardNumber(creditCardNumber)
								}
							/>
							<TextInput
								id={`${this.state.showNewCard ? 'hidden' : 'cardPrintedName'
									}`}
								className={`cardPrintedName field-show-${this.state.showNewCard}`}
								label="Nome impresso no cartão"
								maxLength={26}
								style={{ textTransform: 'uppercase' }}
								normalize
								{...this.props}
							/>
							<PureSelect
								id={`${this.state.showNewCard
									? 'hidden'
									: 'cardMonthValidity'
									}`}
								className={`card-month-validity validity-field field-show-${this.state.showNewCard}`}
								label="Validade"
								placeholder="Mês"
								options={[
									{ value: '01', label: '01' },
									{ value: '02', label: '02' },
									{ value: '03', label: '03' },
									{ value: '04', label: '04' },
									{ value: '05', label: '05' },
									{ value: '06', label: '06' },
									{ value: '07', label: '07' },
									{ value: '08', label: '08' },
									{ value: '09', label: '09' },
									{ value: '10', label: '10' },
									{ value: '11', label: '11' },
									{ value: '12', label: '12' }
								]}
								{...this.props}
							/>
							<PureSelect
								id={`${this.state.showNewCard
									? 'hidden'
									: 'cardYearValidity'
									}`}
								className={`card-year-validity validity-field field-show-${this.state.showNewCard}`}
								placeholder="Ano"
								options={cardYearValidityOptions}
								{...this.props}
							/>
							<TextInput
								id={`${this.state.showNewCard ? 'hidden' : 'cardNumberToken'
									}`}
								className={`cardNumberToken field-show-${this.state.showNewCard}`}
								style={{ textTransform: 'uppercase' }}
								normalize
								{...this.props}
							/>
							<TextInput
								id={`${this.state.showNewCard ? 'hidden' : 'cardId'}`}
								className={`cardId field-show-${this.state.showNewCard}`}
								normalize
								{...this.props}
							/>
						</div>
					</div>

					{!this.state.showNewCard ? (
						<div
							className={`more-information-${this.props.values.selectsavecard}`}>
							<span className="holdername-savecard">
								Titular:{' '}
								{`${cardOpen !== {} ? cardOpen.cardPrintedName : null}`}
							</span>
							<span className="vality-savecard">
								Validade:{' '}
								{cardOpen !== {}
									? `${cardOpen.cardMonthValidity}/${cardOpen.cardYearValidity}`
									: `00/00`}
							</span>
							<SecurityCodeInput
								id="securityCode"
								className="security-code"
								label="Cód. de segurança"
								style={{ width: '20%' }}
								maxLength={4}
								{...this.props}
							/>
							<PureSelect
								{...this.props}
								id="installments"
								label="Parcelamento"
								className="installments"
								placeholder="Selecione..."
								options={installmentOptions}
								handleChange={e => {
									this.props.setInstallments(e.target.value)
									return this.props.handleChange(e)
								}}
								noOptionsMessage={`nao`}
							/>
						</div>
					) : null}
				</div>
				<div className="new-card-toggle-container">
					<Checkbox
						id="payment-new-card"
						onChange={() => {
							this.renderWithOtherCard()
						}}
					/>
					<span className="new-card-toggle-label">
						Pagar com outro cartão
					</span>
				</div>
				<div
					className={`new-card-fields-container-${this.state.showNewCard
						} ${!this.state.showNewCard ? 'show-field-container' : ''}`}>
					<CreditCardFields {...this.props} />
				</div>
			</React.Fragment>
		)
	}
}

const mapStateToProps = ({ creditCardPurchase }) => ({
	cardBrand: creditCardPurchase.cardBrand,
	creditCardNumber: creditCardPurchase.creditCardNumber
})

const mapDispatchToProps = {
	setCardBrand: CreditCardPurchaseCreators.setCardBrand,
	setInstallments: CreditCardPurchaseCreators.setInstallments,
	setCreditCardNumber: CreditCardPurchaseCreators.setCreditCardNumber,
	hideLoading: SiteCreators.hideLoading,
	showLoading: SiteCreators.showLoading
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SaveCreditCardFields)
